import { Translation } from '@ps/web-shared-components';
import React from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import useWizardJump from '@swf/core/hooks/useWizardJump';

import type { HelpSection } from '../../../../types/Cashier';
import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';
import TransactionsPanel from '../../../TransactionsPanel/TransactionsPanel';
import HelpSectionContent from '../HelpSectionContent/HelpSectionContent';

import {
  TXTWCL_Verify_payment_method,
  TXTWCL_Verify_payment_methods,
  TXTWCL_Why_verify_your_payment_method_ELL,
  TXTWCL_You_canXt_withdraw_right_now,
  TXTWCL_You_need_to_verify_your_paymen_ELL,
  TXTWCL_You_need_to_verify_your_paymen_ELL_1
} from './PaymentVerificationLobby.messages.json';

const helpSection: HelpSection = {
  title: TXTWCL_Why_verify_your_payment_method_ELL,
  body: <HelpSectionContent />
};

const PaymentVerificationLobby: React.FC = () => {
  const {
    values: {
      withdraw: { balanceCurrency }
    },
    data: { unverifiedOptions }
  } = useWizardContext();
  const { jumpBack } = useWizardJump();
  const goBack = () => jumpBack('#withdraw.withdraw-amount');

  return (
    <Container
      headerProps={{
        title: <Translation {...TXTWCL_You_canXt_withdraw_right_now} />,
        buttons: {
          back: true,
          onBackClick: goBack
        }
      }}
      page={PaymentVerificationLobby}
      helpSupportResolver
      showFooter
      pageTopTitle={<Translation {...TXTWCL_You_canXt_withdraw_right_now} />}
      pageTopSubtitle={
        <Translation
          {...(unverifiedOptions.length > 1
            ? TXTWCL_You_need_to_verify_your_paymen_ELL_1
            : TXTWCL_You_need_to_verify_your_paymen_ELL)}
        />
      }
      helpSection={helpSection}
    >
      <TransactionsPanel
        balanceCurrency={balanceCurrency}
        rollbackOverCreditOptions={unverifiedOptions}
        isVerification
      />
      <CTAButton
        translation={
          unverifiedOptions.length > 1
            ? TXTWCL_Verify_payment_methods
            : TXTWCL_Verify_payment_method
        }
      />
    </Container>
  );
};

PaymentVerificationLobby.displayName = 'PaymentVerificationLobby';

export default PaymentVerificationLobby;
